import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';
import 'moment/locale/uk';
import 'moment/locale/de';
import 'moment/locale/ru';
import 'moment/locale/sv';
import 'moment/locale/zh-cn';
import en from './locales/en';
import uk from './locales/uk';
import de from './locales/de';
import ru from './locales/ru';
import sv from './locales/sv';
import zhCN from './locales/zh-CN';
Vue.use(VueI18n);
const SUPPORTED = ['en', 'uk', 'de', 'ru', 'zh-CN', 'sv'];
export function isAppLocale(value) {
    return SUPPORTED.includes(value);
}
const HTML_LANG = {
    en: 'en',
    uk: 'uk',
    de: 'de',
    ru: 'ru',
    'zh-CN': 'zh-CN',
    sv: 'sv',
};
function detectBrowserLocale() {
    if (typeof navigator === 'undefined') {
        return null;
    }
    const lang = (navigator.language || '').toLowerCase();
    if (lang.startsWith('uk'))
        return 'uk';
    if (lang.startsWith('de'))
        return 'de';
    if (lang.startsWith('ru'))
        return 'ru';
    if (lang.startsWith('zh'))
        return 'zh-CN';
    if (lang.startsWith('sv'))
        return 'sv';
    if (lang.startsWith('en'))
        return 'en';
    return null;
}
export function getInitialLocale() {
    try {
        const saved = localStorage.getItem('locale');
        if (saved !== null && isAppLocale(saved)) {
            return saved;
        }
    }
    catch {
        /* ignore */
    }
    return detectBrowserLocale() ?? 'en';
}
const MOMENT_LOCALE = {
    en: 'en',
    uk: 'uk',
    de: 'de',
    ru: 'ru',
    'zh-CN': 'zh-cn',
    sv: 'sv',
};
const initialLocale = getInitialLocale();
export const i18n = new VueI18n({
    locale: initialLocale,
    fallbackLocale: 'en',
    messages: { en, uk, de, ru, 'zh-CN': zhCN, sv },
    silentTranslationWarn: process.env.NODE_ENV === 'production',
});
moment.locale(MOMENT_LOCALE[initialLocale]);
export function setAppLocale(locale) {
    const next = isAppLocale(locale) ? locale : 'en';
    i18n.locale = next;
    moment.locale(MOMENT_LOCALE[next]);
    document.documentElement.lang = HTML_LANG[next];
    try {
        localStorage.setItem('locale', next);
    }
    catch {
        /* ignore */
    }
}
